import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";
const API_URL = BASE_URL + "/index.php/Api/get_hijama_banners_list";

function BannerAPI1() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    axios.get(API_URL)
      .then((res) => setBanners(res.data.data || []))
      .catch((err) => console.log(err));
  }, []);

  // ⭐ FIX: Jab tak banners API se nahi aate, kuch bhi render mat karo
  if (banners.length === 0) return null;

  return (
    <div className="container-fluid px-0">
      <div className="row g-0">
        <div className="col-12">

          <div
            id="carouselDynamic"
            className="carousel slide carousel-fade"
            data-bs-ride="carousel"
            data-bs-interval="2000"
          >

            <div className="carousel-inner">
              {banners.map((item, index) => (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                  style={{
                    backgroundImage: `url(${BASE_URL}/${item.banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "66vh",
                  }}
                ></div>
              ))}
            </div>

            <button
              className="carousel-control-prev ms-2"
              type="button"
              data-bs-target="#carouselDynamic"
              data-bs-slide="prev"
            >
              <i className="bi bi-chevron-left viewAll viewAll1"></i>
            </button>

            <button
              className="carousel-control-next me-2"
              type="button"
              data-bs-target="#carouselDynamic"
              data-bs-slide="next"
            >
              <i className="bi bi-chevron-right viewAll viewAll1"></i>
            </button>

          </div>

        </div>
      </div>
    </div>
  );
}

export default BannerAPI1;
